import { states, COMPANY_REGISTRATION_TYPE_ARRAY } from "../../../../Menu/util/constants"

export default {
	stateArray: states,
	states: Object.values(states),
	registrationTypes: COMPANY_REGISTRATION_TYPE_ARRAY
}
